module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-doctors__item-wrap main-border"
  }, [_c('div', {
    staticClass: "box flex clear_fix hr"
  }, [_c('div', {
    staticClass: "box__avatar-wrap"
  }, [_c('router-link', {
    staticClass: "link_black",
    attrs: {
      "to": {
        name: 'SingleDoctor',
        query: {
          id: _vm.doctor._id
        }
      }
    }
  }, [_c('user-avatar', {
    attrs: {
      "data": _vm.doctor,
      "setClass": 'box__avatar_doc-item user_fix'
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box__content box__stars"
  }, [_c('h4', {
    staticClass: "box__title box__title_doc-item underline"
  }, [_c('router-link', {
    staticClass: "link_black",
    attrs: {
      "to": {
        name: 'SingleDoctor',
        query: {
          id: _vm.doctor._id
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.doctor.last_name) + " " + _vm._s(_vm.doctor.first_name) + " " + _vm._s(_vm.doctor.middle_name) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box__labels-wrap"
  }, _vm._l((_vm.doctor.specializations), function(item) {
    return _c('span', {
      staticClass: "box__label"
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), (_vm.doctor.doctor_type) ? _c('div', {
    staticClass: "box__purpose-wrap"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.doctor.doctor_type.indexOf('childish') != -1),
      expression: "doctor.doctor_type.indexOf('childish') != -1"
    }],
    staticClass: "box__purpose-item"
  }, [_vm._v("Детский")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.doctor.doctor_type.indexOf('adult') != -1),
      expression: "doctor.doctor_type.indexOf('adult') != -1"
    }],
    staticClass: "box__purpose-item"
  }, [_vm._v("Взрослый")])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "box__paragraph bold"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.doctor.category) + " " + _vm._s(_vm.doctor.degree) + " " + _vm._s(_vm.doctor.experience) + "\n\t\t\t")]), _vm._v(" "), _c('rating', {
    attrs: {
      "stars": _vm.doctor.mark,
      "reviewCount": _vm.doctor.mark_count
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.doctor.works), function(work) {
    return _c('div', {
      staticClass: "box flex clear_fix hr"
    }, [_c('div', {
      staticClass: "box__avatar-wrap"
    }, [_c('router-link', {
      staticClass: "link_black fix",
      attrs: {
        "to": {
          name: 'SingleClinic',
          query: {
            id: work.clinic_id
          }
        }
      }
    }, [_c('user-avatar', {
      attrs: {
        "data": work,
        "setClass": 'box__avatar box__avatar_clinic'
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "box__content box__content_clinic"
    }, [_c('div', {
      staticClass: "box__title box__title_clinic"
    }, [_c('router-link', {
      staticClass: "link_black",
      attrs: {
        "to": {
          name: 'SingleClinic',
          query: {
            id: work.clinic_id
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(work.clinic_name) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('p', {
      staticClass: "box__paragraph"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(work.clinic_city.country.name) + ",\n\t\t\t\t" + _vm._s(work.clinic_city.region.name) + ",\n\t\t\t\t" + _vm._s(work.clinic_city.name) + ",\n\t\t\t\tул. " + _vm._s(work.clinic_street) + ",\n\t\t\t\t" + _vm._s(work.clinic_house) + "\n\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "box__paragraph"
    }, _vm._l((work.specializations), function(item) {
      return _c('span', [_vm._v(_vm._s(item.name))])
    }))]), _vm._v(" "), _c('create-visit-button', {
      attrs: {
        "work": work,
        "appointment": _vm.appointment
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c4810b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thumbnails/DoctorThumbnail.vue
// module id = 604
// module chunks = 0